/* eslint-disable prettier/prettier */
import React from 'react'
import { Container } from '../styles/ComplementacaoLayout'

const Complementacao = () => (
  <Container>
      <div>
        <h2>Complementação Profissional</h2>
        <ul>
          <li>↪ 01 Qualificação Profissional Técnica de Nível Médio:</li>
          <li>↪ Avaliador de Imóveis – CBO – 3544-10</li>
        </ul>
        <h2>Para os alunos</h2>
        <p>
          concluintes no CPET o mesmo deverá executar curso complementar com 80 horas <br />
          não concluintes no CPET o mesmo deverá solicitar analise de aproveitamento de conteúdo
        </p>
        <h2>Registro Profissional :</h2>
        <p>
          CRECI – Conselho Regional de Corretores de Imóveis <br />
          A carteira de estagiário será emitida somente no Estado do Rio Grande do Norte pelo CRECI-RN, nos demais 
          Estados da Federação o registro profissional será emitido somente após o término do Curso.
        </p>
      </div>
  </Container>
)

export default Complementacao